/* src/app/core/widgets/qr-gen/qr-gen.component.scss */
/*# sourceMappingURL=qr-gen.component.css.map */
